import { useFetch } from './useFetch';
import { useEffect, useState } from 'react';
import { useOperator } from '../contexts/OperatorContext';
import { BASE_URL_MAP } from '../lib/environment';

export interface RemoteButton {
  id: number;
  category: string;
  color: string;
  icon: boolean;
  name: string;
  order: number;
  shape: string;
}

interface ApiRemoteButton {
  Id: number;
  Category: string;
  Color: string;
  Icon: boolean;
  Name: string;
  Order: number;
  Shape: string;
}

type Action = '' | 'sendcommand';

export const useRemote = () => {
  const [action, setAction] = useState<Action>('');
  const [buttons, setButtons] = useState<RemoteButton[]>([]);
  const { loading, makeRequest, response } = useFetch(true);
  const operator = useOperator();

  useEffect(() => {
    if (response && !loading && action !== 'sendcommand') {
      setButtons(
        response.map((b: ApiRemoteButton) => ({
          category: b.Category,
          color: b.Color,
          icon: b.Icon,
          id: b.Id,
          name: b.Name,
          order: b.Order,
          shape: b.Shape,
        })) ?? []
      );

      setAction('');
    }
  }, [response, loading]);

  const getRemoteButtons = () => {
    makeRequest(
      `${BASE_URL_MAP[operator.type]}/${operator.id}/CitrusView/Buttons`,
      'get'
    );
  };

  const sendCommand = (buttonId: number) => {
    setAction('sendcommand');
    makeRequest(
      `${BASE_URL_MAP[operator.type]}/${
        operator.id
      }/CitrusView/Buttons/${buttonId}`,
      'post'
    );
  };

  return {
    buttons,
    getRemoteButtons,
    sendCommand,
    loading,
  };
};
